<template lang="pug">
	modal(:max-width="500")
		.card.text-left
			.card-header
				span.fa.fa-edit.mr-2
				span Rechazar
				button.close(@click="cerrar") &times;
			.card-body
				.form-group
					label
						b Motivos del rechazo
					textarea.form-control(
						v-model="datos.ComentariosFinales"
						rows="6"
						placeholder="Explica por qué motivo rechazas esta tarea"
					)
			.card-footer
				button.btn.btn-primary(@click="rechazar")
					span.fa.fa-ban.mr-2
					span Rechazar tarea
</template>

<script>
import axios from 'axios'
export default {
	props: ['TareaID'],
	data () {
		return {
			datos: {
				TareaID: null,
				ComentariosFinales: ''
			}
		}
	},
	methods: {
		rechazar () {
			this.datos.TareaID = this.TareaID

			if (!this.datos.ComentariosFinales) {
				this.$error('Error', 'No has proporcionado ningún motivo')
				return
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar tarea',
				mensaje: `¿Quieres rechazar esta tarea?`,
				callback: acepta => {
					if (acepta) {
						axios.post('produccion-audiovisual/php/api/rechazar.php', this.datos)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Tarea rechazada'
								})
								this.$emit('rechazada')
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/detalles/rechazarTarea.component.vue